import React, { useEffect, useMemo, useState } from 'react';

import { FaExclamationCircle } from 'react-icons/fa';

import TagManager from 'react-gtm-module';
import {
  Container,
  Attention,
  Gpt,
  Current,
  Steps,
  Access,
  Dear,
  Banner,
} from './styles';
import Player from '~/components/Player';
import thumbFree from '~/assets/defaults/thumb-free.webp';
import quote from '~/assets/icons/quote-pink-thanks.svg';
import logo from '~/assets/logos/logo.svg';
import union1 from '~/assets/defaults/union-1.svg';
import union2 from '~/assets/defaults/union-2.svg';
import Footer from '~/components/Footer';
import DisclaimerNew from '~/components/DisclaimerNew';
import api from '~/services/api';

const AireWelcome: React.FC = () => {
  const [name, setName] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [tempPass, setTempPass] = useState<string>();
  const userData = useMemo(() => {
    const data = localStorage.getItem('@AutoAffiliate:userData');
    if (data) {
      return JSON.parse(data);
    }
    return undefined;
  }, []);

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: 'GTM-PKCCSK8S',
    };
    TagManager.initialize(tagManagerArgs);
  }, []);

  useEffect(() => {
    if (userData !== undefined) {
      api
        .get(`users/admin/${userData.user_id || userData.id}`)
        .then((response) => {
          setName(response.data.name);
          setEmail(response.data.email);
          setTempPass(response.data.temp_pass);
        });
    }
  }, [userData, userData?.id, userData?.user_id]);
  return (
    <Container className="posiiton-relative">
      <Attention className="">
        <div className="container zoom">
          <div className="row">
            <div className="col zoom">
              <h2 className="text-white mb-0 py-3 text-center">
                <FaExclamationCircle />
                <b className="ms-3">DO NOT CLOSE THIS PAGE YET!: </b>
                Please <b>Read Everything on This Page Carefully</b> to Prevent
                Future Issues With Accessing Your New Account.
              </h2>
            </div>
          </div>
        </div>
      </Attention>
      <div className="position-absolute w-100 px-2 px-md-5">
        <Banner className="position-relative">
          <img src={union1} alt="Union" className="union-1 d-none d-lg-block" />
          <img src={union2} alt="Union" className="union-2 d-none d-lg-block" />
          <svg
            className="cross-top-left"
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            fill="none"
          >
            <path
              d="M7 1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 1-1-1V1z"
              fill="#ada8c4"
            />
          </svg>
          <svg
            className="cross-top-right"
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            fill="none"
          >
            <path
              d="M7 1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 1-1-1V1z"
              fill="#ada8c4"
            />
          </svg>
          <svg
            className="cross-bottom-right"
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            fill="none"
          >
            <path
              d="M7 1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 1-1-1V1z"
              fill="#ada8c4"
            />
          </svg>
          <svg
            className="cross-bottom-left"
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            fill="none"
          >
            <path
              d="M7 1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 1-1-1V1z"
              fill="#ada8c4"
            />
          </svg>
          <div className="d-flex justify-content-center align-items-center ">
            <div className="d-flex justify-content-center align-items-center circle-1 mt-n4">
              <div className="d-flex justify-content-center align-items-center circle-2">
                <div className="d-flex justify-content-center align-items-center circle-3">
                  <div className="d-flex justify-content-center align-items-center circle-4">
                    <div className="d-flex justify-content-center align-items-center circle-5" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="square-pink" />
          <div className="square-dark-blue" />
          <div className="square-blue" />
          <div className="square-black-1 d-none d-lg-block" />
          <div className="square-black-2 d-none d-lg-block" />
        </Banner>
      </div>
      <Gpt>
        <div className="container zoom">
          <div className="row justify-content-center">
            <div className="col-xxl-10 px-lg-0">
              <h1 className="text-center mt-4 mt-sm-3 pt-4 mb-1">
                🎉Congratulations!
                <br />
                <span className="d-block pt-4">
                  Your AI Revenue Engine is Ready
                </span>
              </h1>
              <h2>
                Watch the video below for important <span>next steps</span> to
                start using <span>PostEASE & AI Connector+ immediately.</span>
              </h2>
            </div>

            <div className="col-lg-9 mb-4">
              <Player
                id="video"
                src="https://cdn.autoaffiliate.ai/videos/post-purchase-pe-and-aic-installation-video.mp4"
                thumbnail={thumbFree}
                autoPlay={!!name}
              />
            </div>
          </div>
        </div>
      </Gpt>

      <Steps>
        <div className="container zoom">
          <div className="row justify-content-center">
            <div className="col-lg-10 mb-4">
              <h2 className="my-sm-5 pb-4 pb-sm-5">
                How to <u>access everything:</u>
              </h2>
              <div className="d-flex align-items-start">
                <h3 className="mb-4 mb-sm-5">
                  Before closing this page please complete the{' '}
                  <span>following steps:</span>
                </h3>
                <img src={quote} alt="Quote" className="quote" />
              </div>
            </div>
            <div className="col-11 col-sm-12 px-sm-0">
              <div className="row">
                <div className="col-lg-6 p-4 p-sm-5 step1 border-gray-left mb-4 mb-lg-0">
                  <h4>1st Step</h4>
                  <hr className="w-50" />
                  <h5 className="py-3">Check your email</h5>
                  <p className="mb-3">
                    We’ve sent you <span>two important emails:</span>
                  </p>
                  <ul className="ps-0 mb-1">
                    <li>
                      📩 <span>Email 1</span> – Your{' '}
                      <span className="text-white">login credentials</span>{' '}
                      (username & password).
                    </li>
                    <li>
                      📩 <span>Email 2</span> – Step-by-step setup instructions
                      to get started fast.
                    </li>
                  </ul>
                  <h6 className="mt-4 mb-0 d-flex">
                    Log In Credentials: <span className="border-bottom" />
                  </h6>
                  <p>Email: {email ?? 'email'}</p>
                  <p>Password: {tempPass ?? 'password'}</p>
                </div>
                <div className="col-lg-6 p-4 p-sm-5 step2 border-gray-right">
                  <h4>2nd Step</h4>
                  <hr className="w-50" />
                  <h5 className="pb-1">
                    Download & Install PostEASE & AI Connector+
                  </h5>
                  <p className="mb-3">
                    Both run as Chrome extensions.{' '}
                    <b>Click below to download & install.</b>
                  </p>
                  <p>Log in with the same credentials from Step 1.</p>
                  <p className="fw-semibold mb-0">
                    One login. Two powerful tools.
                  </p>
                  <ul className="ps-0 mb-3">
                    <li>
                      🔹 <span className="fw-semibold">PostEASE</span> automates
                      content.
                    </li>
                    <li>
                      🔹 <span className="fw-semibold">AI Connector+</span>{' '}
                      finds leads & closes sales.
                    </li>
                  </ul>
                  <p className="mb-0">
                    Need help? Click the support bubble in the lower right or
                    email{' '}
                    <a href="mailto:support@autoaffiliate.ai">
                      support@autoaffiliate.ai
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Steps>
      <div className="position-relative">
        <div className="circle-large-1" />
        <div className="circle-large-2" />
      </div>
      <Access>
        <div className="container zoom">
          <div className="row justify-content-center">
            <div className="col-lg-11 px-xxl-5">
              <div className="text-center pt-5">
                <h2 className="mt-sm-5">
                  Get Started Now!
                  <br />
                  <span>
                    Click Below to Download & Access Your AI Automation Suite:
                  </span>
                </h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-5 px-lg-3">
              <a
                href="https://chromewebstore.google.com/detail/ai-connector/fmcefkadmedfpbfbjnkfgbfkjfpijadh"
                target="_blank"
                className="w-100 d-flex justify-content-center align-items-center btn-download-ai mt-5"
                rel="noreferrer"
              >
                Download AI Connector Here
              </a>
            </div>
            <div className="col-lg-5 px-lg-3">
              <a
                href="https://chromewebstore.google.com/detail/postease/opjnalnkbedcahnheieejogpbaiomojp"
                target="_blank"
                className="w-100 d-flex justify-content-center align-items-center btn-download-pe mt-5"
                rel="noreferrer"
              >
                Download PostEASE Here
              </a>
            </div>
          </div>
        </div>
      </Access>

      <Dear>
        <img src={logo} alt="Logo" className="logo" />
        <div className="container zoom">
          <div className="row justify-content-center">
            <div className="col-12 p-4 p-sm-5 my-4">
              <h2 className="mb-4">Dear {name ?? 'member'},</h2>
              <h3 className="mb-4">
                We’re absolutely thrilled to welcome you to the AI Revenue
                Engine!{' '}
              </h3>
              <p className="mb-4">
                You’ve just unlocked PostEASE & AI Connector+, two powerful
                tools designed to automate your content, generate leads, and
                close sales hands-free. This isn’t just another tool—it’s a
                complete AI-powered system built to help you scale faster, work
                smarter, and achieve real results.
              </p>

              <p className="mb-4">
                We’re committed to your success, and every feature inside has
                been crafted to make your growth effortless and automated.
              </p>
              <p className="mb-4">What’s Next?</p>
              <p className="mb-0">
                ✅ PostEASE – AI-powered content creation & engagement
                automation.
              </p>
              <p className="mb-4">
                ✅ AI Connector+ – AI-driven lead generation & sales automation.
              </p>
              <p className="mb-4">
                As a valued AutoAffiliate member, you also get access to
                exclusive resources, ongoing support, and cutting-edge AI tools
                to help you thrive online.
              </p>
              <p className="mb-4">
                🔥 Log in, explore, and let AI work for you 24/7!
              </p>
              <h4>- The AutoAffiliate Team</h4>
            </div>
          </div>
        </div>
      </Dear>
      <div className="position-relative">
        <div className="circle-large-3" />
      </div>
      <Current>
        <div className="container zoom">
          <div className="row justify-content-center">
            <div className="col-sm-11 my-sm-5 py-5 disclaimer">
              <DisclaimerNew />
            </div>
          </div>
        </div>
      </Current>
      <Footer />
    </Container>
  );
};

export default AireWelcome;
